import { Input } from 'antd';
import React, { memo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getComtZtList } from '../../actions/comment';

const selectComment = createSelector(
  state => state.comment,
  comment => comment,
);

function SelectZt(props) {
  const { onSelect } = props;
  const { ztList } = useSelector(selectComment);
  const dispatch = useDispatch();
  const [value, setValue] = useState('');

  const handleChange = useCallback(
    ev => {
      ev.persist();
      const inputValue = ev.target.value.trim();
      setValue(inputValue);
      if (inputValue) {
        dispatch(getComtZtList({ searchWord: inputValue }));
      }
    },
    [value],
  );

  return (
    <div className="insert-box">
      {value && ztList && (
        <ul className="box-list">
          {ztList.length > 0 &&
            ztList.map((el, idx) => {
              return (
                <li
                  className="list-item"
                  key={idx}
                  onClick={e => {
                    e.stopPropagation();
                    onSelect && onSelect({ ztId: el.ztId, name: el.ztTitle });
                    setValue(null);
                  }}
                  dangerouslySetInnerHTML={{
                    __html: el.ztTitle,
                  }}
                />
              );
            })}
        </ul>
      )}
      <Input
        placeholder="请输入专题名称"
        type="text"
        value={value}
        onChange={handleChange}
        autoFocus
      />
    </div>
  );
}

export default memo(SelectZt);
